import {
    GET_CITY_REQUEST,
    GET_CITY_SUCCESS,
    GET_CITY_ERROR,

} from "./types"
import axios from "axios";
import { BASEURL } from "../../constant/config.js"

export const loadCity = (token, id) => dispatch => {
    dispatch({ type: GET_CITY_REQUEST });
    return axios({
        method: "GET",
        url: `${BASEURL}getOne/adminCity/${id}`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: GET_CITY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_CITY_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_CITY_ERROR,
                payload: error.response,
            });
        })
};

